<template>
  <div
    class="character-card"
    @click="clickHandler"
  >
    <lazy-component class="lazy-component">
      <van-image
        width="100%"
        height="100%"
        fit="contain"
        :src="item.cover"
      />
      <span v-show="!item.locked && item.video" class="play-icon" />
    </lazy-component>
    <span
      v-show="item.locked"
      class="locked"
    >vip</span>
    <p class="text">{{ item.title }}</p>
  </div>
</template>

<script>
export default {
  name: 'CharacterCard',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
  },
  methods: {
    clickHandler () {
      this.$emit('clickHandler')
    }
  }
}
</script>

<style scoped lang="scss">
.character-card {
  height: 100%;
  position: relative;
  .lazy-component {
    position: relative;
    width: 100%;
    height: 60px;
    .play-icon {
      @include bg-image-png('/video/play-icon');
      @include bg-image-fit;
      @include wh(30px, 30px);
      @include ct();
      opacity: 0.5;
    }
  }
  .locked {
    @include wh(20px, 9px);
    @include sc(6px, #fff);
    @include lw(9px);
    @include lg-radius(#ECCEA2, #E7B170, 3px);
    text-align: center;
    position: absolute;
    right: 2px;
    top: 2px;
  }
  .text {
    text-align: center;
    font-size: 16px;
  }
}
</style>
